import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Trusted for Authentication field definition
 * Boolean field with Yes/No dropdown for trusted for authentication status filtering
 */
export const ADObjectTrustedForAuth = createBooleanSimpleFilterDefinition(
  'trustedtoauth',
  'Trusted for Authentication'
);
